<script>
import ModalsTemplate from "../ModalsTemplate.vue";

import { mapActions } from "vuex";

import toDate from "@/service/to-date.js";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    ModalsTemplate,
  },

  data: () => ({
    object: {
      id: null,

      name: null,

      // names: {
      //   uz: null,
      //   ru: null,
      //   en: null,
      // },

      active: true,

      startDate: null,
      endDate: null,
    },

    model: true,
  }),

  watch: {
    model() {
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    },
  },

  created() {
    if (this.data.id) {
      this.object = JSON.parse(JSON.stringify(this.data));
      this.object.startDate = this.$date(this.object.startDate);
      this.object.endDate = this.$date(this.object.endDate);
    }
  },

  methods: {
    ...mapActions("admin-admission-session", ["ADD_ADMISSION_SESSION"]),

    onSend() {
      if (this.$refs.form.validate()) {
        const params = { ...this.object };

        params.startDate = toDate(params.startDate);
        params.endDate = toDate(params.endDate);
        params.registrationEndDate = toDate(params.registrationEndDate);

        this.ADD_ADMISSION_SESSION(params).then((status) => {
          if (status != null) {
            this.$emit("refresh");
            this.model = false;
          }
        });
      }
    },
  },
};
</script>

<template>
  <modals-template
    :title="$t('Admission session')"
    :width="650"
    v-model="model"
  >
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-text-field
            autofocus
            autocomplete="off"
            v-model="object.name"
            :label="$t('Name')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
          />
        </v-col>
        <!-- <v-col cols="12">
          <v-text-field
            autofocus
            autocomplete="off"
            v-model="object.names.uz"
            :label="$t('Name uz')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            autocomplete="off"
            v-model="object.names.ru"
            :label="$t('Name ru')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            autocomplete="off"
            v-model="object.names.en"
            :label="$t('Name en')"
            outlined
            hide-details
          />
        </v-col> -->
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.startDate"
            :label="$t('Start date')"
            outlined
            hide-details
            v-inputmask="$masks.date"
            required
            :rules="[$rules.required, $rules.date]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.endDate"
            :label="$t('End date')"
            outlined
            hide-details
            v-inputmask="$masks.date"
            required
            :rules="[$rules.required, $rules.date]"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.registrationEndDate"
            :label="$t('Registration end date')"
            outlined
            hide-details
            v-inputmask="$masks.date"
            required
            :rules="[$rules.required, $rules.date]"
          />
        </v-col>
      </v-row>
    </v-form>

    <template slot="actions">
      <div class="d-flex w-100">
        <v-spacer />
        <v-btn color="primary" class="btn-accent" @click="onSend">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </template>
  </modals-template>
</template>
